import React from 'react'

const Companies = ({ className }) => (
  <div className={`companies row ${className}`}>
    <div className="zapier" alt="Zapier" />
    <div className="wistia" alt="Wistia" />
    <div className="grubhub" alt="Grubhub" />
  </div>
)

export default Companies
